import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Salvaged from ui-sprocket src/components/ColorModeToggle.tsx — reviewed 2026-09-21: icons
// from the package icon set; the group is labelled by its caption (`aria-labelledby`)
// instead of a duplicate aria-label; otherwise unchanged.
import { useId } from 'react';
import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';
import { DarkModeIcon, LightModeIcon, SettingsBrightnessIcon } from '../icons.js';
import { useColorMode } from '../theme/color-mode.js';
const OPTIONS = [
    { value: 'light', label: 'Light', icon: _jsx(LightModeIcon, { fontSize: "small" }) },
    { value: 'dark', label: 'Dark', icon: _jsx(DarkModeIcon, { fontSize: "small" }) },
    { value: 'system', label: 'System', icon: _jsx(SettingsBrightnessIcon, { fontSize: "small" }) },
];
/**
 * Light / Dark / System, as a segmented control. "System" is offered as its own option
 * rather than inferred, because following the OS is a real preference and not the same
 * as having picked whichever mode the OS is on today.
 */
export function ColorModeToggle() {
    const { preference, setPreference } = useColorMode();
    const labelId = useId();
    return (_jsxs(Box, { sx: { px: 2, py: 1 }, children: [_jsx(Typography, { id: labelId, variant: "caption", color: "text.secondary", sx: { display: 'block', mb: 0.75 }, children: "Appearance" }), _jsx(ToggleButtonGroup, { size: "small", exclusive: true, value: preference, 
                // `null` arrives when the active button is clicked again; keep the current choice.
                onChange: (_e, next) => next && setPreference(next), "aria-labelledby": labelId, fullWidth: true, children: OPTIONS.map((option) => (_jsxs(ToggleButton, { value: option.value, sx: { gap: 0.75 }, children: [option.icon, option.label] }, option.value))) })] }));
}
//# sourceMappingURL=color-mode-toggle.js.map